import "./Meta.scss";
import { LegalLinks } from "../LegalLinks";

export function Meta() {
	return (
		<div className="score-breakdown-meta">
			<div className="score-breakdown-meta__footnote">
				<p>
					If a score is not displayed for a given technology, the data is
					unavailable.
				</p>
			</div>
			<div className="score-breakdown-meta__powered-by">
				<p>
					<a href="https://atelier.net/" target="_blank" rel="noreferrer">
						Powered by
						<br />
						L'Atelier BNP Paribas
					</a>
				</p>
				<div className="score-breakdown-meta__powered-by__legal-links">
					<LegalLinks />
				</div>
			</div>
		</div>
	);
}
